'use client';
import { FC } from 'react';

import CampainCard from '@shared/CampainCard';
import {
  SFCampaignPromotionItemViewModel,
  CloudinaryImageViewModel,
} from '@api/index';
import Carousel from '@components/Carousel/Carousel';
import { useBreakpoint } from '@contexts/breakpoints';

import { CarouselWrapper, SwiperSlider, Wrapper } from './styled';

export type CampainListType = {
  data: Array<SFCampaignPromotionItemViewModel>;
};

const CampainList: FC<CampainListType> = ({ data }) => {
  const { xl } = useBreakpoint();

  const getUseLazyLoad = (index: number) => {
    if (xl === undefined || xl === null) return false; // SSR/initial render
    return xl ? index >= 4 : index >= 1;
  };

  return (
    <div>
      {data ? (
        <Wrapper>
          <CarouselWrapper>
            <Carousel
              loop={false}
              navigation={true}
              spaceBetween={0}
              slidesPerView='auto'
            >
              {data.map((campaign: SFCampaignPromotionItemViewModel, index) => (
                <SwiperSlider key={campaign.href}>
                  <CampainCard
                    key={index}
                    href={campaign.href}
                    title={campaign.title}
                    image={campaign.image as CloudinaryImageViewModel}
                    lastDate={campaign.lastDate || ''}
                    ticketImage={
                      campaign.ticketImage as CloudinaryImageViewModel
                    }
                    useLazyLoad={getUseLazyLoad(index)}
                  />
                </SwiperSlider>
              ))}
            </Carousel>
          </CarouselWrapper>
        </Wrapper>
      ) : null}
    </div>
  );
};

export default CampainList;
